module.exports = __webpack_public_path__ + "static/media/splitCheckThirdScreen.355c4e7c.png";